import { render, staticRenderFns } from "./Segments.vue?vue&type=template&id=74ec9e18"
import script from "./Segments.vue?vue&type=script&lang=js"
export * from "./Segments.vue?vue&type=script&lang=js"
import style0 from "./Segments.vue?vue&type=style&index=0&id=74ec9e18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports